interface RenderTableProps {
  columns: string[]
  data: (string | number)[][]
}

function RenderTable({ columns, data }: RenderTableProps) {
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th
              key={index}
              style={{
                border: '1px solid var(--border-color)',
                padding: '8px',
                backgroundColor: 'var(--bg-color-secondary)',
                color: 'var(--text-color)',
              }}
            >
              {column}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <td
                key={cellIndex}
                style={{
                  border: '1px solid var(--border-color)',
                  padding: '8px',
                  color: 'var(--text-color)',
                }}
              >
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default RenderTable
